<template></template>

<script>
import firebase from "firebase/app";
import { store } from "../store";

export default {
  name: "logout",
  created() {
    firebase
      .auth()
      .signOut()
      .then(() => {
        //this.$store.commit("setIamtheboss", false);
        //this.$store.commit("setNickname", "");

        this.$router.replace("/login");
      });
  }
};
</script>
